import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { PRE_ACTIVATION_BADGE } from "../../../i18n/keysTranslations";
import { GREY_COLOR, PAPER_BACKGROUND_COLOR } from "../../../utils/colors";

const Card = ({ children, section = "" }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: PAPER_BACKGROUND_COLOR,
        borderRadius: "16px",
        padding: "36px 36px 32px",
        marginBottom: "16px",
        boxShadow: "0 2px 16px rgba(0, 0, 0, 0.06)",
      }}
    >
      {section ? (
        <Typography
          sx={{
            fontSize: "9px",
            fontWeight: 800,
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            color: "text.secondary",
            marginBottom: "20px",
          }}
        >
          {section}
        </Typography>
      ) : (
        <Typography
          sx={{
            display: "inline-block",
            background: GREY_COLOR,
            color: "text.secondary",
            fontSize: "10px",
            fontWeight: 700,
            letterSpacing: "1px",
            textTransform: "uppercase",
            padding: "4px 12px",
            borderRadius: "6px",
            marginBottom: "16px",
          }}
        >
          {t(PRE_ACTIVATION_BADGE)}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default Card;
